// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout_container__szNaY","container-cms-page":"PageLayout_container-cms-page__pZz4g"};